import React from 'react';
import styled from 'styled-components/macro';
import { WxCheckbox, WxLabel } from '../..';
import { AttributeKey } from '../../../hooks/api/queries/useAttributes';
import useProducts from '../../../hooks/api/queries/useProducts';
import {
  sortings,
  useFiltersContext,
} from '../../../hooks/context/useFiltersContext';
import { getPercentiles } from '../../../hooks/utils/getPercentiles';
import { __ } from '../../../i18n/l10n';
import { DesktopOnly } from '../../layout/nav/DesktopNavbar';
import { AttributeFilter } from './AttributeFilter';
import { RangeFilter } from './RangeFilter';
import { SortingFilter } from './SortingFilter';

interface Props {
  attrKeys: AttributeKey[];
  categoryId: number;
}
export const DesktopFilters = ({ attrKeys, categoryId }: Props) => {
  const { onlyAvailable, setOnlyAvailable, subCatList } = useFiltersContext();

  const productsFilter = {
    categoryId,
    subCatList,
    attributes: [],
    attrKeyCount: 0,
    sort: [],
    skip: 0,
  };

  const { data } = useProducts(productsFilter);

  if (!data) return null;

  return (
    <DesktopOnly>
      <FlexRow>
        {attrKeys
          .filter((key) => key.values.length > 1 && key.hideFilter !== 1)
          .map((key) => {
            if (key.id === 1) return null;
            return (
              <FlexColumn key={`key-${key.id}`}>
                <WxLabel label={key.keyLabel} black />
                {key.values
                  .sort((a, b) => {
                    if (a.valueSorting === null) return 1;
                    else if (b.valueSorting === null) return -1;
                    return a.valueSorting - b.valueSorting;
                  })
                  .map((value) => (
                    <AttributeFilter
                      attribute={value}
                      device="desktop"
                      key={`atttribute-d-${value.id}`}
                    />
                  ))}
              </FlexColumn>
            );
          })}
        <FlexColumn>
          <WxLabel label={__('Miles')} black />
          {getPercentiles(data.results).map((range, index) => (
            <React.Fragment key={`filter-range-d-${index}`}>
              <RangeFilter r={range} />
            </React.Fragment>
          ))}
        </FlexColumn>
        <FlexColumn>
          <WxLabel label={__('Sort')} black />

          {sortings.map((sort) => (
            <SortingFilter sort={sort} key={`sort-desk-${sort.value}`} />
          ))}
          <WxCheckbox
            key={`attr-only-avail`}
            label={__('Show only products I can buy')}
            noUppercase
            selected={onlyAvailable}
            onSelect={() => setOnlyAvailable(!onlyAvailable)}
          />
        </FlexColumn>
      </FlexRow>
    </DesktopOnly>
  );
};

const FlexRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 1.25rem;
`;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  width: calc(100% / 6);

  > :first-child {
    margin-bottom: 0.625rem;
  }
`;
